import { useEffect } from 'react';

export default function useNodeSize(nodeRef, callback) {
  let timeout;

  useEffect(() => {
    const tick = () => {
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }

      timeout = window.requestAnimationFrame(() => {
        if (!nodeRef || !nodeRef.current) {
          return;
        }
        const {
          offsetWidth,
          offsetHeight,
          clientWidth,
          clientHeight,
        } = nodeRef.current;
        callback({ offsetWidth, offsetHeight, clientWidth, clientHeight });
      });
    };
    tick();
    window.addEventListener('resize', tick);
    return () => window.removeEventListener('resize', tick);
  }, []);
}
